export const PROJECT = process.env.REACT_APP_PROJECT;
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export const LOCIZE_PROJECT_ID = process.env.REACT_APP_LOCIZE_PROJECT_ID;
export const LOCIZE_VERSION = process.env.REACT_APP_LOCIZE_VERSION;

export const RECENT_SEARCHES_KEY = "savedSearchQueries";
export const RECENT_POIS_KEY = "savedPoiQueries";
export const FALLBACK_LANGUAGE = "en-GB";
